import { BaseSyntheticEvent } from 'react';

export const preventDefaults = (event: BaseSyntheticEvent) => {
  event.preventDefault();
  event.stopPropagation();
};
